/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/**
 * Global cart loading state
 * Used by product list components
 */

type CartLoadingListener = (isLoading: boolean) => void;

let isCartLoading = false;
const listeners = new Set<CartLoadingListener>();

export const getCartLoadingState = (): boolean => {
    return isCartLoading;
};

export const setCartLoadingState = (loading: boolean): void => {
    if (isCartLoading === loading) {
        return;
    }

    isCartLoading = loading;

    listeners.forEach(listener => {
        try {
            listener(loading);
        } catch (error) {
            console.error('Error in cart loading listener:', error);
        }
    });
};

export const subscribeToCartLoading = (callback: CartLoadingListener): (() => void) => {
    listeners.add(callback);
    return () => listeners.delete(callback);
};
